import {
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  SECONDARY_COLORS,
  WARNING_COLORS,
} from 'components/constants';
import { RangeType } from 'types';

export const DATEPICKER_ALLTIME_ID = 'all';

export const INVITE_ERROR = 'inviteError';
export const ALL_CANDIDATES = 'all';
export const TOP_PERFORMER = 'top';

export type ChartTypes = CandidateStatus.OFFERED | 'all' | 'top';

export enum CandidateStatus {
  OFFERED = 'offered',
  HIRED = 'hired',
  DISMISSED = 'dismissed',
  PENDING = 'pending',
  ACTIVE = 'active',
}

export const DATEPICKER_OPTIONS = [
  { id: DATEPICKER_ALLTIME_ID, label: 'All time' },
  { id: 'month', label: 'Last 30 days' },
  { id: 'week', label: 'Last 7 days' },
  { id: 'custom', label: 'Custom' },
] as Array<RangeType>;

export const CANDIDATE_FUNNEL_CARD_LABELS = [
  { key: 'acceptedInvite', label: 'Accepted' },
  { key: 'invited', label: 'Invited' },
];

export const CANDIDATE_COMPLETION_FUNNEL_CARD_LABELS = [
  { key: 'candidatesWith2References', label: 'Completed' },
  { key: 'invited', label: 'Invited' },
];

export const REFERENCE_FUNNEL_CARD_LABELS = [
  { key: 'completed', label: 'Completed' },
  { key: 'invited', label: 'Invited' },
];

export const candidateStatusToColor = {
  [CandidateStatus.OFFERED]: PRIMARY_COLORS[1],
  [CandidateStatus.ACTIVE]: SECONDARY_COLORS[1],
  [CandidateStatus.HIRED]: SUCCESS_COLORS[1],
  [CandidateStatus.DISMISSED]: WARNING_COLORS[1],
} as Record<CandidateStatus, string>;

export const PIE_CHART_LABELS: Array<{
  key: CandidateStatus;
  label: string;
  color: string;
}> = [
  {
    key: CandidateStatus.OFFERED,
    label: 'Offered',
    color: candidateStatusToColor[CandidateStatus.OFFERED],
  },
  {
    key: CandidateStatus.ACTIVE,
    label: 'Active',
    color: candidateStatusToColor[CandidateStatus.ACTIVE],
  },
  {
    key: CandidateStatus.HIRED,
    label: 'Hired',
    color: candidateStatusToColor[CandidateStatus.HIRED],
  },
  {
    key: CandidateStatus.DISMISSED,
    label: 'Dismissed',
    color: candidateStatusToColor[CandidateStatus.DISMISSED],
  },
];

export const CHART_OPTIONS = {
  [CandidateStatus.OFFERED]: {
    color: SUCCESS_COLORS[0],
    text: 'Offered / Hired',
  },
  [ALL_CANDIDATES]: {
    color: SECONDARY_COLORS[0],
    text: 'All Candidates',
  },
  [TOP_PERFORMER]: {
    color: PRIMARY_COLORS[0],
    text: 'Top Performer',
  },
};

export const REVIEW_VIEW = 'review-reporting';
